import { styled } from '@mui/material/styles';

import { Theme, rem } from '../../theme';
import { Heading } from '../Heading';
import { ImageStandalone } from '../ImageStandalone';
import { Paragraph } from '../Paragraph';

export const StyledWrapper = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        display: flex;
        flex-direction: column;
        width: 100%;
        height: ${theme.tggSpacing('auto', 'auto')};
        margin: ${theme.tggSpacing(0, 0)};
        overflow: hidden;
        border-radius: ${theme.tggSpacing(0, 0)};

        ${theme.breakpoints.up('desktop')} {
            width: calc(100% - ${theme.tggSpacing(rem(6), 15)});
            margin: ${theme.tggSpacing([0, rem(3)], [0, 7.5])};
            border-radius: ${theme.tggSpacing([0, 0, rem(2), rem(2)], [0, 0, 5, 5])};
        }
        ${theme.breakpoints.up(1024)} {
            flex-direction: row;
            align-items: stretch;
            margin: ${theme.tggSpacing([0, 'auto'], [0, 'auto'])};
        }
        ${theme.breakpoints.up('largeDesktop')} {
            max-width: ${theme.tggSpacing(rem(128), 320)};
        }
    `}
`;

export const StyledImageContainer = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        position: relative;
        flex-grow: 1;
        width: 100%;
        height: ${theme.tggSpacing('auto', 'auto')};
        min-height: ${theme.tggSpacing(rem(20), 50)};
        overflow: hidden;

        ${theme.breakpoints.up('desktop')} {
            min-height: ${theme.tggSpacing(rem(30), 75)};
        }
        ${theme.breakpoints.up(1024)} {
            flex: 1 1 50%;
            width: 50%;
        }
    `}
`;

export const StyledImageStandalone = styled(ImageStandalone)`
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

export const StyledTextContainer = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        position: relative;
        display: flex;
        flex-grow: 1;
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
        height: ${theme.tggSpacing('auto', 'auto')};
        min-height: ${theme.tggSpacing(rem(22), 55)};
        padding: ${theme.tggSpacing([rem(2), rem(4), rem(3)], [5, 10, 7.5])};
        background-color: ${theme.palette.grey[50]};

        ${theme.breakpoints.up(768)} {
            min-height: ${theme.tggSpacing(rem(22), 55)};
            padding-bottom: ${theme.tggSpacing(rem(3.5), 8.75)};
        }
        ${theme.breakpoints.up(1024)} {
            width: 50%;
            padding: ${theme.tggSpacing([rem(5.95), rem(4)], [24, 10])};
            margin: ${theme.tggSpacing([0, 'auto'], [0, 'auto'])};
        }
    `}
`;

export const StyledHeading = styled(Heading)`
    ${({ theme }: { theme: Theme }) =>
        theme.typography.text_25_bold_desktop_31};
    ${({ theme }: { theme: Theme }) => `
        margin-bottom: ${theme.tggSpacing(rem(2), 5)};
        ${theme.breakpoints.up('desktop')} {
            margin-bottom: ${theme.tggSpacing(rem(3), 7.5)};
        }
    `}
`;

export const StyledParagraph = styled(Paragraph)`
    ${({ theme }: { theme: Theme }) => theme.typography.text_16_lh_22};
    ${({ theme }: { theme: Theme }) => `
        margin-bottom: ${theme.tggSpacing(rem(2), 5)};    
        ${theme.breakpoints.up('desktop')} {
            margin-bottom: ${theme.tggSpacing(rem(3), 7.5)};
        }
    `}
`;

export const StyledForm = styled('form')`
    width: 100%;
    .rejoinEmailComponentError {
        position: absolute;
    }
`;
